import { render } from "./ForumsSelectTree.vue?vue&type=template&id=0553a989&scoped=true"
import script from "./ForumsSelectTree.vue?vue&type=script&lang=js"
export * from "./ForumsSelectTree.vue?vue&type=script&lang=js"

import "./ForumsSelectTree.vue?vue&type=style&index=0&id=0553a989&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0553a989"]])

export default __exports__